export var Kube360Subjects;
(function (Kube360Subjects) {
    Kube360Subjects["Kube360Page"] = "kube360-page";
    Kube360Subjects["SideFilter"] = "kube360-side-filter";
    Kube360Subjects["Kube360Footer"] = "kube360-footer";
    Kube360Subjects["CheckMapView"] = "check-map-view";
    Kube360Subjects["CheckTableView"] = "check-table-view";
    Kube360Subjects["SwitchViewMode"] = "switch-view-mode";
    Kube360Subjects["FilterContainer"] = "filter-container";
    Kube360Subjects["GroupPodsByTypeSelector"] = "group-pods-by-type-selector";
    Kube360Subjects["SwitchMetric"] = "switch-metric";
    Kube360Subjects["LegendMetricTypePrefix"] = "legend-metric-type-";
    Kube360Subjects["LegendNumberPrefix"] = "legend-number-";
    Kube360Subjects["LoadingKubeMapCard"] = "loading-kube-map-card";
    Kube360Subjects["EmptyStateTitle"] = "empty-state-title";
    Kube360Subjects["EmptyStateText"] = "empty-state-text";
    Kube360Subjects["KubeMapCard"] = "kube-map-card";
    Kube360Subjects["QuickView"] = "kube360-quickview";
    Kube360Subjects["CloseQuickView"] = "kube360-closeQuickView";
    Kube360Subjects["QuickViewTitle"] = "kube360-quickview-title";
    Kube360Subjects["QuickViewTitleType"] = "kube360-quickview-title-type";
    Kube360Subjects["OverviewCardRow"] = "overview-card-row";
    Kube360Subjects["OverviewCardRowLabel"] = "overview-card-row-label";
    Kube360Subjects["QuickViewLogsEmptyState"] = "quick-view-logs-empty-state";
    Kube360Subjects["QuickViewSpansEmptyState"] = "quick-view-spans-empty-state";
    Kube360Subjects["PodsTableEmptyState"] = "pods-table-empty-state";
    Kube360Subjects["PodsTabTable"] = "pods-tab-table";
    Kube360Subjects["PodsTable"] = "pods-table";
    Kube360Subjects["TracesTable"] = "traces-table";
    Kube360Subjects["IItemTable"] = "item-table";
    Kube360Subjects["AttachItemToAi"] = "attach-item-to-ai";
    Kube360Subjects["AskOrionIqAboutItem"] = "ask-orion-iq-about-item";
})(Kube360Subjects || (Kube360Subjects = {}));
//# sourceMappingURL=kube360.enum.js.map